0/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


document.addEventListener('DOMContentLoaded', () => {
  const widthOptionsByProduct = {
    'sisalwool 100': {
      'Pack': ['370mm - 2.67m2 (6 slabs)', '570mm - 4m2 (6 slabs)'],
      'Pallet': ['370mm - 29.3m2 (66 slabs)', '570mm - 24.6m2 (36 slabs)']
    },
     'sisalwool silent 100': {
      'Pack': ['370mm - 2.67m2 (6 slabs)', '570mm - 4m2 (6 slabs)'],
      'Pallet': ['370mm - 29.3m2 (66 slabs)', '570mm - 24.6m2 (36 slabs)']
    },
    'sisalwool 50': {
      'Pack': ['370mm - 4.88m2 (11 slabs)', '570mm - 8m2 (12 slabs)'],
      'Pallet': ['370mm - 53.7m2 (121 slabs)', '570mm - 48m2 (72 slabs)']
    },
    'sisalwool silent 50': {
      'Pack': ['370mm - 4.88m2 (11 slabs)', '570mm - 8m2 (12 slabs)'],
      'Pallet': ['370mm - 53.7m2 (121 slabs)', '570mm - 48m2 (72 slabs)']
    },
    'sisalwool loftroll': {
      'Pack': ['570mm - 1.71m2 (individual roll)'],
      'Pallet': ['570mm - 47.8m2 (28 rolls)', '570mm - 23.9m2 (14 rolls)']
    }
  };

  const productTitle = document.querySelector('.product__title.heading-size-7')?.textContent.trim().toLowerCase();
  //alert(productTitle);
  const productConfig = widthOptionsByProduct[productTitle];
  if (!productConfig) return;

  // Selectors based on the provided markup
  const unitSizePopout = document.querySelector('[aria-controls="-select-unit-size"]')?.closest('.select-popout');
  const widthPopout = document.querySelector('[aria-controls="-select-width"]')?.closest('.select-popout');

  if (!unitSizePopout || !widthPopout) return;

  const unitSizeInput = unitSizePopout.querySelector('input[data-popout-input]');
  const widthInput = widthPopout.querySelector('input[data-popout-input]');
  const unitSizeOptions = unitSizePopout.querySelectorAll('.select-popout__option');
  const widthOptions = widthPopout.querySelectorAll('.select-popout__option');

function filterWidthOptions(selectedUnit) {
  const allowedWidths = productConfig[selectedUnit] || [];

  let firstVisibleOption = null;

  widthOptions.forEach(option => {
    const value = option.getAttribute('data-value')?.trim();
    const item = option.closest('.select-popout__item');

    if (allowedWidths.includes(value)) {
      item.style.display = '';
      if (!firstVisibleOption) firstVisibleOption = option;
    } else {
      item.style.display = 'none';
      option.removeAttribute('aria-current');
    }
  });

  if (firstVisibleOption) {
    const value = firstVisibleOption.getAttribute('data-value');
    widthInput.value = value;

    widthOptions.forEach(opt => opt.removeAttribute('aria-current'));
    firstVisibleOption.setAttribute('aria-current', 'true');

    const toggle = widthPopout.querySelector('.select-popout__toggle');
    if (toggle) toggle.textContent = value;

    widthInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}


  unitSizeOptions.forEach(option => {
    option.addEventListener('click', e => {
      e.preventDefault();
      const selectedUnit = option.getAttribute('data-value');

      unitSizeInput.value = selectedUnit;

      unitSizeOptions.forEach(opt => opt.removeAttribute('aria-current'));
      option.setAttribute('aria-current', 'true');

      const toggle = unitSizePopout.querySelector('.select-popout__toggle');
      if (toggle) toggle.textContent = selectedUnit;

      unitSizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      filterWidthOptions(selectedUnit);
    });
  });

  // Run once on page load
  filterWidthOptions(unitSizeInput.value);
});






